import { getApplication } from '@ms/yammer-telemetry';

type IsTeamsBrandedExperience = () => boolean;
export const isTeamsBrandedExperience: IsTeamsBrandedExperience = () =>
  getApplication() === 'YammerTeamsBrandedExperiencesApp';
